import { ThemeColors } from '~/themes/colors'

export interface ScrollingListColors {
  Background: {
    Default: ThemeColors
  }
  Border: ThemeColors
  Item: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
  }
}

export const scrollingListColors: ScrollingListColors = {
  Background: {
    Default: {
      default: 'gray.200',
    },
  },
  Border: {
    default: 'gray.100',
  },
  Item: {
    Background: {
      Default: {
        default: 'achromatic.transparent',
      },
      Hover: {
        default: 'gray.400',
      },
      Active: {
        default: 'gray.600',
      },
    },
  },
}
